import { useQuery } from "@apollo/client";

import { GET_BET_OPTION_LIST } from "../queries/asset";
import {
  GET_ALL_NOTIFICATIONS,
  GET_MESSAGE_NOTIFICATIONS,
} from "../queries/message";
import { showErrorToast } from "../../components/common/CustomErrorMessage";
import { GET_BET_LIST } from "../queries/game";
import {
  FETCH_ADMIN,
  FETCH_COUNTRIES,
  FETCH_DASHBOARD,
  FETCH_ROOMS,
  GET_MEMBER_LIST,
} from "../queries/management";
import { GET_TRANSACTION_REQUEST } from "../queries/transaction";
import { GET_BRANCH_LIST } from "../queries/branch";
import { GET_CURRENT_USER } from "../queries/auth";

export const useBetOptionQuery = () => {
  const {
    loading,
    data: { betOptionList } = {},
    error,
  } = useQuery(GET_BET_OPTION_LIST, {
    onError(error) {
      showErrorToast(error.message);
    },
  });

  return { loading, betOptionList, error };
};

export const useQueryAllNotifications = () => {
  const {
    loading,
    data: { allChatNotifications } = {},
    error,
    refetch,
  } = useQuery(GET_ALL_NOTIFICATIONS, {
    onError(error) {
      showErrorToast(error.message);
    },
  });

  return { loading, allChatNotifications, error, refetch };
};

export const useQueryMemberNotifications = (variables) => {
  const {
    loading,
    data: { memberChatNotifications } = {},
    error,
    refetch,
  } = useQuery(GET_MESSAGE_NOTIFICATIONS, {
    variables,
    onError(error) {
      showErrorToast(error.message);
    },
  });

  return { loading, memberChatNotifications, error, refetch };
};

export const useBetQuery = (variables) => {
  const {
    loading,
    data: { getBetListAdmin } = {},
    error,
    refetch,
  } = useQuery(GET_BET_LIST, {
    variables,
    onError(error) {
      showErrorToast(error.message);
    },
  });

  return { loading, getBetListAdmin, error, refetch };
};

export const useCountryQuery = (variables) => {
  const {
    loading,
    data: { getCountryList } = {},
    error,
    refetch,
  } = useQuery(FETCH_COUNTRIES, {
    variables,
    onError(error) {
      showErrorToast(error.message);
    },
  });

  return { loading, getCountryList, error, refetch };
};

export const useDashboardQuery = (variables) => {
  const {
    loading,
    data: { fetchDashboard } = {},
    error,
    refetch,
  } = useQuery(FETCH_DASHBOARD, {
    variables,
    onError(error) {
      showErrorToast(error.message);
    },
  });

  return { loading, fetchDashboard, error, refetch };
};

export const useMemberQuery = (variables) => {
  const {
    loading,
    data: { memberList } = {},
    error,
    refetch,
  } = useQuery(GET_MEMBER_LIST, {
    fetchPolicy: "cache-and-network",
    variables,
    onError(error) {
      showErrorToast(error.message);
    },
  });

  return { loading, memberList, error, refetch };
};

export const useRoomQuery = () => {
  const {
    loading,
    data: { roomListAdmin } = {},
    error,
    refetch,
  } = useQuery(FETCH_ROOMS, {
    fetchPolicy: "cache-and-network",
    onError(error) {
      showErrorToast(error.message);
    },
  });

  return { loading, roomList: roomListAdmin, error, refetch };
};

export const useTransactionRequestQuery = (action) => {
  const {
    loading,
    data: { getTransactionRequests } = {},
    error,
    refetch,
  } = useQuery(GET_TRANSACTION_REQUEST, {
    variables: { action: action },
    onError(error) {
      showErrorToast(error.message);
    },
  });

  return {
    loading,
    getTransactionRequests,
    error,
    refetchRequestList: refetch,
  };
};

export const useAdminQuery = () => {
  const {
    loading,
    data: { adminList } = {},
    error,
    refetch,
  } = useQuery(FETCH_ADMIN, {
    fetchPolicy: "cache-and-network",
    onError(error) {
      showErrorToast(error.message);
    },
  });

  return { loading, adminList, error, refetch };
};

export const useBranchQuery = () => {
  const {
    loading,
    data: { branchList } = {},
    error,
    refetch,
  } = useQuery(GET_BRANCH_LIST, {
    fetchPolicy: "cache-and-network",
    onError(error) {
      showErrorToast(error.message);
    },
  });

  return { loading, branchList, error, refetch };
};

export const useQueryCurrentUser = () => {
  const {
    loading,
    data: { currentUser } = {},
    error,
    refetch,
  } = useQuery(GET_CURRENT_USER, {
    fetchPolicy: "network-only",
    onError: (error) => showErrorToast(error.message),
  });

  return { loading, currentUser, error, refetch };
};
